
import React, { Component } from "react";
import Swal from "sweetalert2";
import { Modal } from "react-bootstrap";
import Navbar from "../../../components/Navbar.js";
import Select, { components } from "react-select";
import Switch from "react-switch";
import Resizer from "react-image-file-resizer";

import DEBIT002 from "../../../assets/bank/002.png"
import DEBIT004 from "../../../assets/bank/004.png"
import DEBIT006 from "../../../assets/bank/006.png"
import DEBIT011 from "../../../assets/bank/011.png"
import DEBIT014 from "../../../assets/bank/014.png"
import DEBIT022 from "../../../assets/bank/022.png"
import DEBIT024 from "../../../assets/bank/024.png"
import DEBIT025 from "../../../assets/bank/025.png"
import DEBIT030 from "../../../assets/bank/030.png"
import DEBIT033 from "../../../assets/bank/033.png"
import DEBIT034 from "../../../assets/bank/034.png"
import DEBIT066 from "../../../assets/bank/066.png"
import DEBIT067 from "../../../assets/bank/067.png"
import DEBIT069 from "../../../assets/bank/069.png"
import DEBIT070 from "../../../assets/bank/070.png"
import DEBIT071 from "../../../assets/bank/071.png"
import DEBIT073 from "../../../assets/bank/073.png"
import CREDIT1 from "../../../assets/bank/credit1.png"
import CREDIT2 from "../../../assets/bank/credit2.png"
import CREDIT3 from "../../../assets/bank/credit3.png"
import CREDIT4 from "../../../assets/bank/credit4.png"
import CREDIT5 from "../../../assets/bank/credit5.png"

import LOGO from "../../../assets/images/logo.png";
import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    // component
    DatePicker,
} from "../../../components/CustomComponent.js";

import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import "../../../assets/css/index.css";
const { Option } = components
const IconOption = (props) => (
    <Option {...props}> <img src={props.data.icon} style={{ width: 24, marginRight: 16 }} alt={props.data.label} /> {props.data.label} </Option>
)
const bank = [
    { value: "กรุงเทพ", label: "กรุงเทพ", icon: DEBIT002 },
    { value: "กสิกรไทย", label: "กสิกรไทย", icon: DEBIT004 },
    { value: "กรุงไทย", label: "กรุงไทย", icon: DEBIT006 },
    { value: "ทหารไทยธนชาติ", label: "ทหารไทยธนชาติ", icon: DEBIT011 },
    { value: "ไทยพาณิชย์", label: "ไทยพาณิชย์", icon: DEBIT014 },
    { value: "กรุงศรีอยุธยา", label: "กรุงศรีอยุธยา", icon: DEBIT025 },
    { value: "ออมสิน", label: "ออมสิน", icon: DEBIT030 },
    { value: "อาคารสงเคราะห์", label: "อาคารสงเคราะห์", icon: DEBIT033 },
    { value: "เพื่อการเกษตรและสหกรณ์", label: "เพื่อการเกษตรและสหกรณ์", icon: DEBIT034 },
    { value: "อิสลามแห่งปรเทศไทย", label: "อิสลามแห่งปรเทศไทย", icon: DEBIT066 },
    { value: "ทิสโก้", label: "ทิสโก้", icon: DEBIT067 },
    { value: "เกียรตินาคินภัทร", label: "เกียรตินาคินภัทร", icon: DEBIT069 },
    { value: "เครดิตเพื่อรายย่อย", label: "เครดิตเพื่อรายย่อย", icon: DEBIT071 },
    { value: "แลนด์ แอนด์ เฮ้าส์", label: "แลนด์ แอนด์ เฮ้าส์", icon: DEBIT073 },
];
const credit = [
    { value: "มาสเตอร์การ์ด (Master Card)", label: "มาสเตอร์การ์ด (Master Card)", icon: CREDIT1 },
    { value: "วีซ่า (Visa)", label: "วีซ่า (Visa)", icon: CREDIT2 },
    { value: "JCB", label: "JCB", icon: CREDIT3 },
    { value: "American Express", label: "American Express", icon: CREDIT4 },
    { value: "Union Pay", label: "Union Pay", icon: CREDIT5 },
]
export default class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modal_payment: false,
            modal_sub_pay: false,
            loading: false,
            product_list: [],

            data_product: [],
            data_license_plate: [],
            data_member: [],
            data_warehouse: [],
            data_spare: [],
            data_quotation: [],
            data_job: [],
            data_invoice: [],
            data_bill: [],


            goods_issuance_code: "",
            goods_issuance_code_status: false,

            tab: 1,
            picture: "",

            full_name: "",
            brand_id: "",
            model_id: "",
            chassis_number: "",
            engine_number: "",
            license_plate: "",
            policy_number: "",
            payment_number: "",
            date: new Date(),
            due_date: null,
            quotation_ref: "",
            repair_ref: "",
            finance_name: getStorage("user") ? getStorage("user").full_name : "",

            product_id: "",
            qty: "",
            price: "",

            product_list: [],

            remark: "",
            spare_parts_cost: "",
            wage: "",

            discount: "",
            vat: false,

            // PAYMENT 
            total_pay: "",
            change: "",

            bank_name: "",
            transfer_date: null,
            transfer_time: "",
            payment_picture: "",
            pay_remark: "",

            credit_card: "",
            pin_card: "",
            payment_type: 1,

            installments: [],
            installments_count: 0,

            total_price: 0,
            is_payment: true,

            readOnly: false
        }
    }
    async componentDidMount() {

        this.setState({ loading: true });
        await this.getProductAll();
        await this.GetWarehouse();
        await this.GetMember();

        await this.GetSpareAll();
        await this.GetquotationAll();
        await this.GetJobAll();
        await this.GetInvoiceAll();
        await this.GetbillAll();
        if (this.props.location.query.id) {
            this.GetById(this.props.location.query.id)
        }
        this.setState({ loading: false });
    }
    GetById = async (id) => {
        let body = {
            page: 0,
            data_search: "",
            payment_id: id,
            filter_vat: ""
        }
        let result = await GET(tokens, "v1/TH/payment/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log("GetById:", result.data);
            let item = result.data;
            let license_plate = item.license_plate ? this.state.data_license_plate.filter(e => e.value === item.license_plate)[0] : "";
            this.setState({
                license_plate: license_plate.value,
                brand_name: license_plate.brand_name,
                model_name: license_plate.model_name,
                chassis_number: license_plate.chassis_number,
                engine_number: license_plate.machine_number,
                policy_number: license_plate.policy_number,

                payment_type: item.payment_type,

                goods_issuance_code: item.goods_issuance_code ? this.state.data_spare.filter(e => e.value === item.goods_issuance_code)[0] : "",
                goods_issuance_code_status: item.goods_issuance_code ? true : false,
            })
            if (item.quotation_number) {
                await this.GetquotationById(this.state.data_quotation.filter(e => e.value === item.quotation_number)[0].quotation_id);
            }
            if (item.job_number) {
                await this.GetjobById(this.state.data_job.filter(e => e.value === item.job_number)[0].job_id);
            }
            if (item.invoice_number) {
                await this.GetInvoiceById(this.state.data_invoice.filter(e => e.value === item.invoice_number)[0].invoice_id);
            }
            if (item.bill_number) {
                await this.GetbillById(this.state.data_bill.filter(e => e.value === item.bill_number)[0].bill_id);
            }
            setTimeout(() => {
                this.setState({
                    payment_id: id,
                    payment_number: item.payment_number,
                    due_date: item.due_date ? format_date(item.due_date, "yyyy-mm-dd", "en") : null,

                    quotation_number: item.quotation_number ? this.state.data_quotation.filter(e => e.value === item.quotation_number)[0] : "",
                    job_number: item.job_number ? this.state.data_job.filter(e => e.value === item.job_number)[0] : "",
                    invoice_number: item.invoice_number ? this.state.data_invoice.filter(e => e.value === item.invoice_number)[0] : "",
                    bill_number: item.bill_number ? this.state.data_bill.filter(e => e.value === item.bill_number)[0] : "",

                    member_name: item.member_name ? this.state.data_member.filter(e => e.value === item.member_name)[0] : "",

                    is_payment: item.payment_status === 2,

                    total_price: item.total_price ? Number(item.total_price) : 0,

                    remark: item.remark,
                    total_amount: item.total_amount,
                    discount: item.discount,
                    after_discount: item.after_discount,
                    vat: item.vat,
                    net_total_amount: item.net_total_amount,
                    is_vat: item.vat !== 0 ? true : false,

                    // รายการสินค้่า
                    product_list: item.product_list.map(product => {
                        return {
                            product_id: this.state.data_product.filter(e => e.value === product.product_id)[0],
                            level: product.level ? product.level : "",
                            qty_unit: product.qty_unit,
                            price_unit: product.price_unit,
                            discount_by_item: product.discount_by_item,
                            total_price: product.total_price,
                            csd_id: product.csd_id ? product.csd_id : ""
                        }
                    }),

                    readOnly: true,

                    warehouse_id: { value: item.warehouse_id, label: item.warehouse_name }
                });
            }, 10);
        }
    }
    GetSpareAll = async () => {
        let body = {
            page: 0,
            data_search: "",
            goods_issuance_main_id: ""
        }
        let result = await GET(tokens, "v1/TH/goods-issuance-manage/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            // console.log("GetSpareAll:", result.data.filter(e => e.decision_status === 1))
            this.setState({ data_spare: result.data.map(e => { return { value: e.goods_issuance_code, label: e.goods_issuance_code, decision_status: e.decision_status } }) });
        }
    }
    getProductAll = async () => {
        let body = {
            page: 0,
            data_search: "",
            product_code: ""
        }
        let result = await GET(tokens, "v1/TH/product-manage/product/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({ data_product: result.data.map(e => { return { value: e.product_id, label: e.product_name, sell_price: e.sell_price, product_type: e.product_type } }) });
        }
    }
    GetMember = async () => {
        let body = {
            page: 0,
            data_search: "",
            member_id: ""
        }
        let result = await GET(tokens, "v1/TH/member-info/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log("GetMember:", result)
            let data_license_plate = [];
            for (let member of result.data) {
                for (let car_list of member.car_list) {
                    data_license_plate.push({ label: car_list, value: car_list, member_id: member.member_id })
                }
            }
            this.setState({
                data_member: result.data.map(e => { return { value: e.full_name, label: e.full_name, ...e } }),
                data_license_plate: data_license_plate
            });
        }
    }
    GetMemberById = async (id) => {
        let body = {
            page: 0,
            data_search: "",
            member_id: id
        }
        let result = await GET(tokens, "v1/TH/member-info/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log("GetMember:", result)
            console.log("this.state.license_plate:", this.state.license_plate)
            let car = result.data.car_list.filter(e => e.license_plate === this.state.license_plate.value)[0];
            console.log("car:", car)
            this.setState({
                brand_name: car.brand_name,
                model_name: car.model_name,
                member_name: this.state.data_member.filter(e => e.member_id === result.data.member_id)[0],
                policy_number: car.insurance_number,
                chassis_number: car.cassi_number,
                engine_number: car.engine_number
            })
        }
    }
    GetWarehouse = async () => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: ""
        }
        let result = await GET(tokens, "v1/TH/warehouse-info/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({
                data_warehouse: result.data.map(e => {
                    return { value: e.warehouse_id, label: e.warehouse_name }
                })
            });
        }
        this.setState({ loading: false });
    }
    // ใบเสนอราคา 
    GetquotationAll = async () => {
        let body = {
            page: 0,
            data_search: "",
            quotation_id: "",
            type: ""
        }
        let result = await GET(tokens, "v1/TH/quotation/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({ data_quotation: result.data.map(e => { return { value: e.quotation_number, label: e.quotation_number, quotation_id: e.quotation_id } }) });
        }
    }
    GetquotationById = async (id) => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: "",
            quotation_id: id
        }
        let result = await GET(tokens, "v1/TH/quotation/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result.data);
            let item = result.data;
            this.setState({
                // ข้อมูล 
                member_name: item.full_name ? this.state.data_member.filter(e => e.value === item.full_name)[0] : "",
                license_plate: item.license_plate ? this.state.data_license_plate.filter(e => e.value === item.license_plate)[0] : "",
                brand_name: item.brand_name,
                model_name: item.model_name,
                chassis_number: item.chassis_number,
                engine_number: item.machine_number,
                policy_number: item.policy_number,
                // due_date: item.due_date ? item.due_date : null,

                payment_type: item.payment_type,
                installments_count: item.installments.length,
                installments: item.installments,

                remark: item.remark,
                total_amount: 0,
                discount: item.discount,
                after_discount: 0,
                vat: item.vat,
                net_total_amount: 0,
                is_vat: item.vat !== 0 ? true : false,

                // รายการสินค้่า
                product_list: item.product_list.map(product => {
                    return {
                        product_id: this.state.data_product.filter(e => e.value === product.product_id)[0],
                        level: product.level ? product.level : "",
                        qty_unit: product.qty_unit,
                        price_unit: product.price_unit,
                        discount_by_item: product.discount_by_item,
                        total_price: product.total_price,
                        csd_id: product.csd_id ? product.csd_id : ""
                    }
                }),
            })
        }
        this.setState({ loading: false });
    }
    // ใบแจ้งซ่อม
    GetJobAll = async () => {
        let body = {
            page: 0,
            data_search: "",
            job_id: ""
        }
        let result = await GET(tokens, "v1/TH/job-repair/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({ data_job: result.data.filter(e => e.job_status !== 7).map(e => { return { value: e.job_number, label: e.job_number, job_id: e.job_id } }) });
        }
    }
    GetjobById = async (id) => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: "",
            job_id: id
        }
        let result = await GET(tokens, "v1/TH/job-repair/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log("GetjobById::", result.data);
            let item = result.data;
            this.setState({
                // ข้อมูล 
                member_name: item.member_name ? this.state.data_member.filter(e => e.value === item.member_name)[0] : "",
                license_plate: item.license_plate ? this.state.data_license_plate.filter(e => e.value === item.license_plate)[0] : "",
                brand_name: item.brand_name,
                model_name: item.model_name,
                chassis_number: item.chassis_number,
                engine_number: item.machine_number,
                policy_number: item.policy_number,
                // due_date: item.due_date ? item.due_date : null,


                payment_type: item.payment_type,
                installments_count: item.installments.length,
                installments: item.installments,

                remark: "",
                total_amount: 0,
                discount: 0,
                after_discount: 0,
                vat: 0,
                net_total_amount: 0,
                is_vat: false,

                goods_issuance_code: item.goods_issuance_code ? this.state.data_spare.filter(e => e.value === item.goods_issuance_code)[0] : "",
                goods_issuance_code_status: item.goods_issuance_code ? true : false,

                // รายการสินค้่า
                product_list: item.product_list.map(product => {
                    return {
                        product_id: this.state.data_product.filter(e => e.value === product.product_id)[0],
                        level: product.level ? product.level : "",
                        qty_unit: product.qty,
                        price_unit: product.estimated_price,
                        discount_by_item: product.discount_by_item,
                        total_price: product.qty * product.estimated_price,
                        csd_id: product.csd_id ? product.csd_id : ""
                    }
                }),
            })
        }
        this.setState({ loading: false });
    }
    // ใบแจ้งหนี้
    GetInvoiceAll = async () => {
        let body = {
            page: 0,
            data_search: "",
            invoice_id: ""
        }
        let result = await GET(tokens, "v1/TH/quotation/invoice/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({ data_invoice: result.data.filter(item => item.invoice_status === 2).map(e => { return { value: e.invoice_number, label: e.invoice_number, invoice_id: e.invoice_id } }) });
        }
    }
    GetInvoiceById = async (id) => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: "",
            invoice_id: id
        }
        let result = await GET(tokens, "v1/TH/quotation/invoice/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log("GetInvoiceById:", result.data);
            let item = result.data;
            this.setState({
                // ข้อมูล 
                member_name: item.full_name ? this.state.data_member.filter(e => e.value === item.full_name)[0] : "",
                license_plate: item.license_plate ? this.state.data_license_plate.filter(e => e.value === item.license_plate)[0] : "",
                brand_name: item.brand_name,
                model_name: item.model_name,
                chassis_number: item.chassis_number,
                engine_number: item.machine_number,
                policy_number: item.policy_number,
                // due_date: item.due_date ? item.due_date : null,


                payment_type: item.payment_type,
                installments_count: item.installments.length,
                installments: item.installments,

                remark: item.remark,
                total_amount: 0,
                discount: item.discount,
                after_discount: 0,
                vat: item.vat,
                net_total_amount: 0,
                is_vat: item.vat !== 0 ? true : false,

                // รายการสินค้่า
                product_list: item.product_list.map(product => {
                    return {
                        product_id: this.state.data_product.filter(e => e.value === product.product_id)[0],
                        level: product.level ? product.level : "",
                        qty_unit: product.qty_unit,
                        price_unit: product.price_unit,
                        discount_by_item: product.discount_by_item,
                        total_price: product.total_price,
                        csd_id: product.csd_id ? product.csd_id : ""
                    }
                }),
            })
        }
        this.setState({ loading: false });
    }
    // ใบวางบิล
    GetbillAll = async () => {
        let body = {
            page: 0,
            data_search: "",
            bill_id: ""
        }
        let result = await GET(tokens, "v1/TH/quotation/bill/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({ data_bill: result.data.filter(item => item.bill_status === 2).map(e => { return { value: e.bill_number, label: e.bill_number, bill_id: e.bill_id } }) });
        }
    }
    GetbillById = async (id) => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: "",
            bill_id: id
        }
        let result = await GET(tokens, "v1/TH/quotation/bill/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result.data);
            let item = result.data;
            this.setState({
                // ข้อมูล 
                member_name: item.full_name ? this.state.data_member.filter(e => e.value === item.full_name)[0] : "",
                license_plate: item.license_plate ? this.state.data_license_plate.filter(e => e.value === item.license_plate)[0] : "",
                brand_name: item.brand_name,
                model_name: item.model_name,
                chassis_number: item.chassis_number,
                engine_number: item.machine_number,
                policy_number: item.policy_number,
                // due_date: item.due_date ? item.due_date : null,


                payment_type: item.payment_type,
                installments_count: item.installments.length,
                installments: item.installments,

                remark: item.remark,
                total_amount: 0,
                discount: item.discount,
                after_discount: 0,
                vat: item.vat,
                net_total_amount: 0,
                is_vat: item.vat !== 0 ? true : false,

                // รายการสินค้่า
                product_list: item.product_list.map(product => {
                    return {
                        product_id: this.state.data_product.filter(e => e.value === product.product_id)[0],
                        level: product.level ? product.level : "",
                        qty_unit: product.qty_unit,
                        price_unit: product.price_unit,
                        discount_by_item: product.discount_by_item,
                        total_price: product.total_price,
                        csd_id: product.csd_id ? product.csd_id : ""
                    }
                }),
            })
        }
        this.setState({ loading: false });
    }
    Payment = async () => {
        if (Number(this.state.total_pay) < this.state.total_price && this.state.is_payment) {
            alert("warning", "แจ้งเตือน", "ยอดที่ชำระต้องไม่น้อยกว่ายอดรวมทั้งหมด");
            return;
        }
        if (this.state.goods_issuance_code && this.state.goods_issuance_code.decision_status !== 1) {
            alert("warning", "แจ้งเตือน", "กรุณายืนยันการเบิกอะไหล่ ใบเบิกอะไหล่เลขที่ \"" + this.state.goods_issuance_code.value + "\" ก่อนทำการชำระเงิน");
            return;
        }
        console.log(
            (Number(total(this.state.product_list, "total_price") - Number(this.state.discount) + Number(this.state.is_vat ? Number(toFixed((total(this.state.product_list, "total_price") - Number(this.state.discount)) * 0.07).replaceAll(",", "")) : 0)))
        )
        console.log(
            total(this.state.installments.filter(e => e.status === true || e.checked === true), "price")
        )
        let installments_index = [];
        let installments = this.state.installments.map(e => {
            return {
                price: e.price,
                status: (e.status === true || e.checked === true) ? true : false
            }
        })
        for (let i = 0; i < installments.length; i++) {
            if (installments[i].status === true) {
                installments_index.push(i);
            }
        }
        this.setState({ loading: true });
        let body = {
            quotation_number: this.state.quotation_number ? this.state.quotation_number.value : "",
            job_number: this.state.job_number ? this.state.job_number.value : "",
            invoice_number: this.state.invoice_number ? this.state.invoice_number.value : "",
            bill_number: this.state.bill_number ? this.state.bill_number.value : "",
            due_date: this.state.due_date ? format_date(this.state.due_date, "yyyy-mm-dd", "en") : null,
            member_name: this.state.member_name ? this.state.member_name.value : "",
            finance_name: this.state.finance_name,
            license_plate: this.state.license_plate ? this.state.license_plate.label : "",
            remark: this.state.remark,
            total_spare: total(this.state.product_list.filter(e => e.product_id.product_type === "อะไหล่"), "total_price"),
            total_wage: total(this.state.product_list.filter(e => e.product_id.product_type === "การซ่อม"), "total_price"),
            total_amount: Number(total(this.state.product_list, "total_price")),
            discount: Number(this.state.discount),
            after_discount: Number(total(this.state.product_list, "total_price") - Number(this.state.discount)),
            vat: this.state.is_vat ? Number(toFixed((total(this.state.product_list, "total_price") - Number(this.state.discount)) * 0.07).replaceAll(",", "")) : 0,
            net_total_amount: Number(total(this.state.product_list, "total_price") - Number(this.state.discount) + Number(this.state.is_vat ? Number(toFixed((total(this.state.product_list, "total_price") - Number(this.state.discount)) * 0.07).replaceAll(",", "")) : 0)),
            payment_status: this.state.is_payment ? 2 : 1,
            credit_card: this.state.credit_card ? this.state.credit_card.value : "",
            bank_name: this.state.bank_name ? this.state.bank_name.value : "",
            pin_card: this.state.pin_card,
            transfer_date: this.state.transfer_date ? this.state.transfer_date : null,
            transfer_time: this.state.transfer_time ? this.state.transfer_time : null,
            pay_remark: this.state.pay_remark,
            total_price: Number(this.state.total_price),
            total_pay: Number(this.state.total_pay),
            change: Number(
                toFixed(Number(this.state.total_pay) - (this.state.total_price - Number(this.state.discount) + Number(this.state.is_vat ? Number(toFixed((total(this.state.product_list, "total_price") - Number(this.state.discount)) * 0.07).replaceAll(",", "")) : 0))).replaceAll(",", "")),
            payment_type: this.state.tab,
            installments_status: this.state.payment_type === 1 ? true : this.state.payment_type === 2 && (Number(total(this.state.product_list, "total_price") - Number(this.state.discount) + Number(this.state.is_vat ? Number(toFixed((total(this.state.product_list, "total_price") - Number(this.state.discount)) * 0.07).replaceAll(",", "")) : 0)) === total(this.state.installments.filter(e => e.status === true || e.checked === true), "price")) ? true : false,
            installments: installments,
            installments_index: installments_index,
            goods_issuance_code: this.state.goods_issuance_code ? this.state.goods_issuance_code.value : "",
            product_list: this.state.product_list.map(item => {
                return {
                    csd_id: item.csd_id ? item.csd_id : "",
                    product_id: item.product_id ? item.product_id.value : "",
                    qty_unit: Number(item.qty_unit),
                    price_unit: Number(item.price_unit),
                    discount_by_item: Number(item.discount_by_item),
                    total_price: Number(item.total_price),
                    level: item.level ? item.level : ""
                }
            }),
            warehouse_id: this.state.warehouse_id ? this.state.warehouse_id.value : ""
        }
        console.log("BODY:", body)
        let result = await POST(tokens, "v1/TH/payment/create/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            success_url("/sale/list-sale");
        }
        this.setState({ loading: false });
    }
    UpdatePayment = async () => {
        if (Number(this.state.total_pay) < (this.state.total_price - Number(this.sate.discount) + (this.state.is_vat ? Number(toFixed((Number(this.state.total_price) - Number(this.state.discount)) * 0.07).replaceAll(",", "")) : 0)) && this.state.is_payment) {
            alert("warning", "แจ้งเตือน", "ยอดที่ชำระต้องไม่น้อยกว่ายอดรวมทั้งหมด");
            return;
        }
        console.log(this.state.product_list)
        console.log(
            (Number(total(this.state.product_list, "total_price") - Number(this.state.discount) + Number(this.state.is_vat ? Number(toFixed((total(this.state.product_list, "total_price") - Number(this.state.discount)) * 0.07).replaceAll(",", "")) : 0)))
        )
        console.log(
            total(this.state.installments.filter(e => e.status === true || e.checked === true), "price")
        )
        this.setState({ loading: true }); let installments_index = [];
        let installments = this.state.installments.map(e => {
            return {
                price: e.price,
                status: (e.status === true || e.checked === true) ? true : false
            }
        })
        for (let i = 0; i < installments.length; i++) {
            if (installments[i].status === true) {
                installments_index.push(i);
            }
        }
        let body = {
            payment_id: this.state.payment_id,
            quotation_number: this.state.quotation_number ? this.state.quotation_number.value : "",
            job_number: this.state.job_number ? this.state.job_number.value : "",
            invoice_number: this.state.invoice_number ? this.state.invoice_number.value : "",
            bill_number: this.state.bill_number ? this.state.bill_number.value : "",
            due_date: this.state.due_date ? format_date(this.state.due_date, "yyyy-mm-dd", "en") : null,
            member_name: this.state.member_name ? this.state.member_name.value : "",
            finance_name: this.state.finance_name,
            license_plate: this.state.license_plate ? this.state.license_plate.label : "",
            remark: this.state.remark,
            total_spare: total(this.state.product_list.filter(e => e.product_id.product_type === "อะไหล่"), "total_price"),
            total_wage: total(this.state.product_list.filter(e => e.product_id.product_type === "การซ่อม"), "total_price"),
            total_amount: Number(total(this.state.product_list, "total_price")),
            discount: Number(this.state.discount),
            after_discount: Number(total(this.state.product_list, "total_price") - Number(this.state.discount)),
            vat: this.state.is_vat ? Number(toFixed((total(this.state.product_list, "total_price") - Number(this.state.discount)) * 0.07).replaceAll(",", "")) : 0,
            net_total_amount: Number(total(this.state.product_list, "total_price") - Number(this.state.discount) + Number(this.state.is_vat ? Number(toFixed((total(this.state.product_list, "total_price") - Number(this.state.discount)) * 0.07).replaceAll(",", "")) : 0)),
            payment_status: this.state.is_payment ? 2 : 1,
            credit_card: this.state.credit_card ? this.state.credit_card.value : "",
            bank_name: this.state.bank_name ? this.state.bank_name.value : "",
            pin_card: this.state.pin_card,
            transfer_date: this.state.transfer_date ? this.state.transfer_date : null,
            transfer_time: this.state.transfer_time ? this.state.transfer_time : null,
            pay_remark: this.state.pay_remark,
            total_price: Number(this.state.total_price),
            total_pay: Number(this.state.total_pay),
            change: Number(toFixed(Number(this.state.total_pay) - (this.state.total_price - Number(this.state.discount) + Number(this.state.is_vat ? Number(toFixed((total(this.state.product_list, "total_price") - Number(this.state.discount)) * 0.07).replaceAll(",", "")) : 0)).replaceAll(",", ""))),
            payment_type: this.state.tab,
            installments_status: this.state.payment_type === 1 ? true : this.state.payment_type === 2 && (Number(total(this.state.product_list, "total_price") - Number(this.state.discount) + Number(this.state.is_vat ? Number(toFixed((total(this.state.product_list, "total_price") - Number(this.state.discount)) * 0.07).replaceAll(",", "")) : 0)) === total(this.state.installments.filter(e => e.status === true || e.checked === true), "price")) ? true : false,
            installments: installments,
            installments_index: installments_index,
            goods_issuance_code: this.state.goods_issuance_code ? this.state.goods_issuance_code.value : "",
            product_list: this.state.product_list.map(item => {
                return {
                    csd_id: item.csd_id ? item.csd_id : "",
                    product_id: item.product_id ? item.product_id.value : "",
                    qty_unit: Number(item.qty_unit),
                    price_unit: Number(item.price_unit),
                    discount_by_item: Number(item.discount_by_item),
                    total_price: Number(item.total_price),
                    level: item.level ? item.level : ""
                }
            }),
            warehouse_id: this.state.warehouse_id ? this.state.warehouse_id.value : ""
        }
        console.log("BODY:", body)
        let result = await PUT(tokens, "v1/TH/payment/update", body);
        if (result && result.status) {
            success_url("/sale/list-sale");
        }
        this.setState({ loading: false });
    }
    import_file = (e) => {
        this.changePhoto(e.target.files[0])
        document.getElementById("file").value = "";
        document.getElementById("file").file = null;
    }
    changePhoto = async (file) => {
        
        if (!file.type.includes("image")) {
            alert("error", "แจ้งเตือน", "ไม่สามารถอัพโหลดไฟล์ได้เนื่องจากไม่รองรับรูปแบบไฟล์");
            return
        }
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (e) => { }
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file, 512, 512, "JPG", 100, 0,
                (uri) => {
                    this.setState({ picture: uri.split(",")[1] })
                },
                "base64"
            );
        });
    }
    clear = () => {
        this.setState({
            member_name: "",
            brand_name: "",
            model_name: "",
            chassis_number: "",
            engine_number: "",
            license_plate: "",
            policy_number: "",
            payment_number: "",
            date: new Date(),
            due_date: null,
            quotation_ref: "",
            repair_ref: "",
            finance_name: getStorage("user") ? getStorage("user").full_name : "",

            product_id: "",
            qty: "",
            price: "",

            product_list: [],

            remark: "",
            spare_parts_cost: "",
            wage: "",

            discount: "",
            vat: false,

            // PAYMENT 
            total_pay: "",
            change: "",

            bank_name: "",
            transfer_date: null,
            transfer_time: "",
            payment_picture: "",
            pay_remark: "",

            credit_card: "",
            pin_card: "",
            payment_type: 1,

            installments: [],
            installments_count: 0,

            total_price: 0
        })
    }
    render() {
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="ระบบขาย" page3="ระบบชำระเงิน" />
                {/* BODY */}
                <div className="body bg-light min-vh-100 position-relative">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex row mx-0 align-items-center justify-content-between test">
                            <h3 className="mb-2"><b>ระบบชำระเงิน</b></h3>
                        </div>
                        <div className="card p-3 border-0 bg-white" style={{ marginBottom: 100 }}>
                            <div className="row">
                                <div className="col-12 col-md-6 col-lg-3 mb-2">
                                    <label className="mb-2">เลขที่บิลขาย :</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        onChange={(e) => { this.setState({ payment_number: e.target.value }) }}
                                        value={this.state.payment_number}
                                        readOnly
                                    />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3 mb-2">
                                    <label className="mb-2">วันที่ :</label>
                                    <DatePicker
                                        className="form-control"
                                        placeholder="พิมพ์คำค้นหา..."
                                        onChange={(e) => {
                                            this.setState({ date: e });
                                        }}
                                        value={this.state.date}
                                        disabled
                                    />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3 mb-2">
                                    <label className="mb-2">วันครบกำหนดชำระ :</label>
                                    <DatePicker
                                        className="form-control"
                                        placeholder="พิมพ์คำค้นหา..."
                                        onChange={(e) => {
                                            this.setState({ due_date: e });
                                        }}
                                        value={this.state.due_date}
                                    // disabled
                                    />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3 mb-2">
                                    <label className="mb-2">ใบเบิกสินค้า :</label>
                                    <Select
                                        className="form-control select-search"
                                        styles={select_style}
                                        options={this.state.data_spare}
                                        onChange={(e) => {
                                            this.setState({ goods_issuance_code: e });
                                        }}
                                        value={this.state.goods_issuance_code}
                                        isClearable
                                        isDisabled={this.state.goods_issuance_code_status}
                                    ></Select>
                                </div>
                            </div>
                            <hr className="my-2" />
                            <div className="row">
                                <div className="col-12 col-md-6 col-lg-3 mb-2">
                                    <label className="mb-2">อ้างอิงใบเสนอราคา :</label>
                                    <Select
                                        className="form-control select-search"
                                        styles={select_style}
                                        options={this.state.data_quotation}
                                        onChange={(e) => {
                                            this.setState({
                                                quotation_number: e,
                                                job_number: "",
                                                invoice_number: "",
                                                bill_number: "",
                                            });
                                            if (e) {
                                                this.GetquotationById(e.quotation_id)
                                            } else {
                                                this.clear()
                                            }
                                        }}
                                        value={this.state.quotation_number}
                                        isClearable
                                        isDisabled={this.state.readOnly}
                                    ></Select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3 mb-2">
                                    <label className="mb-2">อ้างอิงใบแจ้งซ่อม :</label>
                                    <Select
                                        className="form-control select-search"
                                        styles={select_style}
                                        options={this.state.data_job}
                                        onChange={(e) => {
                                            this.setState({
                                                job_number: e,
                                                quotation_number: "",
                                                invoice_number: "",
                                                bill_number: "",
                                            });
                                            if (e) {
                                                this.GetjobById(e.job_id)
                                            } else {
                                                this.clear()
                                            }
                                        }}
                                        value={this.state.job_number}
                                        isClearable
                                        isDisabled={this.state.readOnly}
                                    ></Select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3 mb-2">
                                    <label className="mb-2">อ้างอิงใบแจ้งหนี้ :</label>
                                    <Select
                                        className="form-control select-search"
                                        styles={select_style}
                                        options={this.state.data_invoice}
                                        onChange={(e) => {
                                            this.setState({
                                                invoice_number: e,
                                                quotation_number: "",
                                                job_number: "",
                                                bill_number: "",
                                            });
                                            if (e) {
                                                this.GetInvoiceById(e.invoice_id)
                                            } else {
                                                this.clear()
                                            }
                                        }}
                                        value={this.state.invoice_number}
                                        isClearable
                                        isDisabled={this.state.readOnly}
                                    ></Select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3 mb-2">
                                    <label className="mb-2">อ้างอิงใบวางบิล :</label>
                                    <Select
                                        className="form-control select-search"
                                        styles={select_style}
                                        options={this.state.data_bill}
                                        onChange={(e) => {
                                            this.setState({
                                                bill_number: e,
                                                quotation_number: "",
                                                job_number: "",
                                                invoice_number: "",
                                            });
                                            if (e) {
                                                this.GetbillById(e.bill_id)
                                            } else {
                                                this.clear()
                                            }
                                        }}
                                        value={this.state.bill_number}
                                        isClearable
                                        isDisabled={this.state.readOnly}
                                    ></Select>
                                </div>
                            </div>
                            <hr className="my-2" />
                            <div className="row">
                                <div className="col-12 col-md-6 col-lg-3 mb-2">
                                    <label className="mb-2">ชื่อลูกค้า :</label>
                                    <Select
                                        className="form-control select-search"
                                        styles={select_style}
                                        options={this.state.data_member}
                                        onChange={(e) => {
                                            this.setState({ member_name: e })
                                            if (e) {
                                                this.setState({
                                                    phone_number: e.phone_number,
                                                    license_plate: "",
                                                    brand_name: "",
                                                    model_name: "",
                                                    address: "",
                                                    type: "",
                                                    policy_number: "",
                                                    chassis_number: "",
                                                    engine_number: ""
                                                });
                                            }
                                        }}
                                        value={this.state.member_name}
                                        isClearable
                                        isDisabled={(this.state.quotation_number || this.state.job_number || this.state.invoice_number || this.state.bill_number || this.state.readOnly)}
                                    ></Select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3 mb-2">
                                    <label className="mb-2">ทะเบียนรถ :</label>
                                    <Select
                                        className="form-control select-search"
                                        styles={select_style}
                                        options={this.state.data_license_plate.filter(e => !this.state.member_name || e.member_id === this.state.member_name.member_id)}
                                        onChange={(e) => {
                                            this.setState({ license_plate: e });
                                            if (e) {
                                                setTimeout(() => {
                                                    this.GetMemberById(e.member_id);
                                                }, 10);
                                            } else {
                                                this.setState({
                                                    brand_name: "",
                                                    model_name: "",
                                                    policy_number: "",
                                                    chassis_number: "",
                                                    machine_number: ""
                                                })
                                            }
                                        }}
                                        value={this.state.license_plate}
                                        isClearable
                                        isDisabled={(this.state.quotation_number || this.state.job_number || this.state.invoice_number || this.state.bill_number || this.state.readOnly)}
                                    ></Select>
                                </div>
                                <div className="col-12 col-md-4 col-lg-3 mb-2">
                                    <label className="mb-2">ยี่ห้อ :</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        onChange={(e) => { this.setState({ brand_name: e.target.value }) }}
                                        value={this.state.brand_name}
                                        readOnly
                                    />
                                </div>
                                <div className="col-12 col-md-4 col-lg-3 mb-2">
                                    <label className="mb-2">รุ่นรถ :</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        onChange={(e) => { this.setState({ model_name: e.target.value }) }}
                                        value={this.state.model_name}
                                        readOnly
                                    />
                                </div>
                                <div className="col-12 col-md-4 col-lg-3 mb-2">
                                    <label className="mb-2">เลขตัวถัง :</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        onChange={(e) => { this.setState({ chassis_number: e.target.value }) }}
                                        value={this.state.chassis_number}
                                        readOnly
                                    />
                                </div>
                                <div className="col-12 col-md-4 col-lg-3 mb-2">
                                    <label className="mb-2">เลขเครื่องยนต์ :</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        onChange={(e) => { this.setState({ engine_number: e.target.value }) }}
                                        value={this.state.engine_number}
                                        readOnly
                                    />
                                </div>

                                <div className="col-12 col-md-4 col-lg-3 mb-2">
                                    <label className="mb-2">เลขกรมธรรม์ :</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        onChange={(e) => { this.setState({ policy_number: e.target.value }) }}
                                        value={this.state.policy_number}
                                        readOnly
                                    />
                                </div>
                                <div className="col-12 col-md-4 col-lg-3 mb-2">
                                    <label className="mb-2">พนักงานการเงิน :</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        onChange={(e) => { this.setState({ finance_name: e.target.value }) }}
                                        value={this.state.finance_name}
                                        readOnly
                                    />
                                </div>
                            </div>
                            <div>
                                <table className="table table-borderless table-striped">
                                    <thead className="bg-primary">
                                        <tr>
                                            <th className="text-center text-white wpx-70">ลำดับ</th>
                                            <th className="text-left text-white">รายการ</th>
                                            <th className="text-center text-white wpx-70">ประเภท</th>
                                            <th className="text-center text-white wpx-100">ระดับ</th>
                                            <th className="text-end text-white wpx-70">จำนวน</th>
                                            <th className="text-end text-white wpx-90">ราคา/หน่วย</th>
                                            <th className="text-end text-white wpx-90">ส่วนลด %</th>
                                            <th className="text-end text-white wpx-90">ราคารวม</th>
                                            {(!this.state.quotation_number && !this.state.job_number && !this.state.invoice_number && !this.state.bill_number) && (
                                                <th className="text-center text-white wpx-60">จัดการ</th>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.product_list && this.state.product_list.map((item, index) => (
                                            <tr key={index}>
                                                <td className="text-center">{index + 1}</td>
                                                <td className="text-left">{item.product_id ? item.product_id.label : "-"}</td>
                                                <td className="text-center">{item.product_id ? item.product_id.product_type : "-"}</td>
                                                <td className="text-center">{item.level ? item.level : "-"}</td>
                                                <td className="text-end">{item.qty_unit ? item.qty_unit : "0"}</td>
                                                <td className="text-end">{item.price_unit ? toFixed(item.price_unit) : "0.00"}</td>
                                                <td className="text-end">{item.discount_by_item ? Number(item.discount_by_item) +" %" : "0.00"}</td>
                                                <td className="text-end">{item.total_price ? toFixed(item.total_price) : "0.00"}</td>
                                                {(!this.state.quotation_number && !this.state.job_number && !this.state.invoice_number && !this.state.bill_number) && (
                                                    <td className="text-center">
                                                        <div className="w-100 d-flex justify-content-center">
                                                            <div className="pointer wpx-30 hpx-30 rounded bg-danger-light mx-1 d-flex justify-content-center align-items-center"
                                                                onClick={() => {
                                                                    Swal.fire({
                                                                        icon: "warning",
                                                                        title: "แจ้งเตือน",
                                                                        text: "ยืนยันการลบ \"" + item.product_id.label + "\" หรือไม่ \nหากลบแล้วจะไม่สามารถย้อนคืนข้อมูลที่ลบไปได้",
                                                                        confirmButtonText: "ตกลง",
                                                                        cancelButtonText: "ยกเลิก",
                                                                        showCancelButton: true,
                                                                    }).then((result) => {
                                                                        if (result.isConfirmed) {
                                                                            let product_list = this.state.product_list;
                                                                            product_list.splice(index, 1);
                                                                            this.setState({ product_list: product_list });
                                                                        }
                                                                    });
                                                                }}>
                                                                <label className="pointer icon text-danger p-2">{"\uf2ed"}</label>
                                                            </div>
                                                        </div>
                                                    </td>
                                                )}
                                            </tr>
                                        ))}
                                        {(!this.state.quotation_number && !this.state.job_number && !this.state.invoice_number && !this.state.bill_number) && (
                                            <tr>
                                                <td className="text-center">
                                                    -
                                                </td>
                                                <td className="text-left">
                                                    <Select
                                                        className="form-control select-search"
                                                        styles={select_style}
                                                        options={this.state.data_product}
                                                        onChange={(e) => {
                                                            this.setState({ product_id: e });
                                                        }}
                                                        value={this.state.product_id}
                                                        isClearable
                                                    ></Select>
                                                </td>
                                                <td className="text-center">{this.state.product_id ? this.state.product_id.product_type : "-"} </td>
                                                <td className="text-center">
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        placeholder=""
                                                        onChange={(e) => {
                                                            this.setState({ level: e.target.value })
                                                        }}
                                                        value={this.state.level}
                                                    />
                                                </td>
                                                <td className="text-center">
                                                    <input
                                                        className="form-control text-end"
                                                        type="text"
                                                        placeholder=""
                                                        onChange={(e) => {
                                                            if (!float(e.target.value)) {
                                                                return
                                                            } this.setState({ quantity: Number(e.target.value) })
                                                        }}
                                                        value={this.state.quantity}
                                                    />
                                                </td>
                                                <td className="text-end">{this.state.product_id ? toFixed(this.state.product_id.sell_price) : "0.00"}</td> 
                                                <td className="text-center">
                                                                <select className="form-control"
                                                                onChange={(e)=>{ 
                                                                    this.setState({ discount_by_item: e.target.value }) 
                                                                }}
                                                                value={this.state.discount_by_item}
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="5">5 %</option>
                                                                    <option value="10">10 %</option>
                                                                </select>
                                                                </td>
                                                <td className="text-end">{this.state.product_id ? toFixed((this.state.product_id.sell_price * Number(this.state.quantity))*((100-Number(this.state.discount_by_item)/100))) : "0.00"}</td>
                                                <td className="text-center">
                                                    <div className="w-100 d-flex justify-content-center">
                                                        <div className="wpx-30 hpx-30 rounded-circle bg-blue text-24 text-white d-flex justify-content-center align-items-center pointer"
                                                            onClick={() => {
                                                                if (!this.state.product_id) {
                                                                    alert("warning", "แจ้งเตือน", "กรุณาเลือกสินค้า");
                                                                    return;
                                                                } else if (!this.state.quantity) {
                                                                    alert("warning", "แจ้งเตือน", "กรุณากรอกจำนวน");
                                                                    return;
                                                                }
                                                                let product_list = this.state.product_list;
                                                                product_list.push({
                                                                    product_id: this.state.product_id,
                                                                    level: this.state.level,
                                                                    qty_unit: this.state.quantity,
                                                                    price_unit: this.state.product_id ? Number(this.state.product_id.sell_price) : 0,
                                                                    discount_by_item: this.state.discount_by_item,
                                                                    total_price: this.state.product_id ?( Number(this.state.product_id.sell_price) * Number(this.state.quantity))*((100-Number(this.state.discount_by_item))/100) : 0
                                                                })
                                                                this.setState({
                                                                    product_list: product_list,
                                                                    product_id: "",
                                                                    level: "",
                                                                    quantity: "",
                                                                })
                                                            }}>+</div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div className="p-3 pb-0">
                                <div className="row">
                                    <div className="col-12 col-md-7 mb-2">
                                        <label className="mb-2">หมายเหตุ :</label>
                                        <textarea
                                            className="form-control"
                                            type="text"
                                            placeholder=""
                                            onChange={(e) => { this.setState({ remark: e.target.value }) }}
                                            value={this.state.remark}
                                            rows={5}
                                            readOnly={this.state.readOnly}
                                        />
                                    </div>
                                    <div className="col-12 col-md-5 mb-2">
                                        <div className="d-flex align-items-center justify-content-between mb-2">
                                            <label>ประเภทการชำระ</label>
                                            <label>{this.state.payment_type === 1 ? "ชำระทั้งหมด" : this.state.payment_type === 2 ? "แบ่งชำระ " + this.state.installments_count + " งวด" : "-"}</label>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between mb-2">
                                            <label>รวมเป็นเงิน</label>
                                            <label>{toFixed(total(this.state.product_list, "total_price"))}</label>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between mb-2">
                                            <label className="me-2">ส่วนลด</label>
                                            {this.state.readOnly ? (
                                                <label>{toFixed(this.state.discount)}</label>
                                            ) : (
                                                <input
                                                    className="form-control text-end"
                                                    type="text"
                                                    placeholder=""
                                                    onChange={(e) => {
                                                        if (!float(e.target.value)) {
                                                            return
                                                        }
                                                        this.setState({ discount: e.target.value })
                                                    }}
                                                    value={this.state.discount}
                                                />
                                            )}
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between mb-2">
                                            <label>ราคาหลังหักส่วนลด</label>
                                            <label>{toFixed(total(this.state.product_list, "total_price") - Number(this.state.discount))}</label>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between mb-2">
                                            <div className="d-flex align-items-center">
                                                {!this.state.readOnly && (
                                                    <Switch onChange={(e) => {
                                                        this.setState({
                                                            is_vat: e,
                                                        })
                                                    }} checked={this.state.is_vat} />
                                                )}
                                                <label className="ms-2">ภาษีมูลค่าเพิ่ม 7%</label>
                                            </div>
                                            <label>{this.state.is_vat ? toFixed((total(this.state.product_list, "total_price") - Number(this.state.discount)) * 0.07).replaceAll(",", "") : "0.00"}</label>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between mb-2">
                                            <label>จำนวนเงินรวมทั้งสิ้น</label>
                                            <label>{toFixed(total(this.state.product_list, "total_price") - Number(this.state.discount) + Number(this.state.is_vat ? toFixed((total(this.state.product_list, "total_price") - Number(this.state.discount)) * 0.07).replaceAll(",", "") : 0))}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="body w-100 position-fixed bg-white p-3 d-flex align-items-center justify-content-end" style={{ bottom: 0 }}>
                    <Switch onChange={(e) => {
                        this.setState({
                            is_payment: e,
                        })
                    }} checked={this.state.is_payment} />
                    <label className="px-2">{this.state.is_payment ? "ชำระ" : "ยังไม่ชำระ"}</label>
                    <button className="btn btn-outline-orange mx-1 px-5" onClick={() => {
                        Swal.fire({
                            icon: "warning",
                            title: "แจ้งเตือน",
                            text: "ยืนยันการล้างข้อมูลหรือไม่",
                            confirmButtonText: "ตกลง",
                            cancelButtonText: "ยกเลิก",
                            showCancelButton: true,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                window.location.href = "/sale/sale/create"
                            }
                        });
                    }}>
                        ยกเลิก
                    </button>
                    <button className="btn btn-orange mx-1 px-5" onClick={() => {
                        if (this.state.payment_type === 1) {
                            if (!this.props.location.query.id) {
                                this.setState({
                                    total_price: (total(this.state.product_list, "total_price") - Number(this.state.discount)),
                                })
                            }
                            this.setState({

                                transfer_date: format_date(new Date(), "yyyy-mm-dd"),
                                transfer_time: format_date(new Date(), "hh:mm"),
                            });
                            if (!this.state.is_payment) {
                                if (this.state.payment_id) {
                                    this.UpdatePayment();
                                } else {
                                    this.Payment();
                                }
                            } else {
                                this.setState({ modal_payment: true, total_price: (total(this.state.product_list, "total_price") - Number(this.state.discount)) })
                            }
                        } else {
                            if (!this.props.location.query.id) {
                                this.setState({ total_price: 0 });
                            }
                            let installments = this.state.installments;
                            for (let i = 0; i < installments.length; i++) {
                                installments[i].checked = false;

                            }
                            this.setState({ modal_sub_pay: true, installments: installments });
                        }

                    }}>
                        {this.state.is_payment ? "ชำระเงิน" : "บันทึกข้อมูล"}
                    </button>
                </div>
                {/* แบ่งเป็นงวด */}
                <Modal show={this.state.modal_sub_pay}
                    onHide={() => { this.setState({ modal_sub_pay: false }) }}>
                    <Modal.Header><Modal.Title><b>ชำระสินค้า</b></Modal.Title></Modal.Header>
                    <Modal.Body>
                        <div className="card bg-light border-0">
                            แบ่งชำระ {this.state.installments_count} งวด
                        </div>
                        <hr className="my-2" />
                        <div className="card border-0 rounded-lg">
                            <table className="table table-borderless">
                                <thead className="bg-primary">
                                    <tr>
                                        <th className="text-center text-white">เลือก</th>
                                        <th className="text-center text-white">งวด</th>
                                        <th className="text-center text-white wpx-300">ราคา</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.installments && this.state.installments.map((item, index) => (
                                        <tr key={index} className="border-bottom">
                                            <td className="text-center">
                                                <input
                                                    className="checkbox"
                                                    type="checkbox"
                                                    onChange={(e) => {
                                                        let installments = this.state.installments;
                                                        // installments[index].checked = e.target.checked;
                                                        for (let i = 0; i < installments.length; i++) {
                                                            if (e.target.checked === true) {
                                                                if (i <= index && !installments[i].status) {
                                                                    installments[i].checked = e.target.checked;
                                                                }
                                                            } else {
                                                                if (i >= index) {
                                                                    installments[i].checked = e.target.checked;
                                                                }
                                                            }
                                                        }
                                                        this.setState({
                                                            installments: installments,
                                                            total_price: (total(installments.filter(e => e.checked), "price")),
                                                        });


                                                    }}
                                                    checked={item.status || item.checked}
                                                    disabled={item.status || this.state.readOnly}
                                                />
                                            </td>
                                            <td className="text-center">{index + 1}</td>
                                            <td className="text-center">{toFixed(item.price)}</td>
                                        </tr>
                                    ))}
                                    {this.state.is_vat && (
                                        <tr className="border-bottom">
                                            <td className="text-center">
                                                ภาษีมูลค่าเพิ่ม 7%
                                            </td>
                                            <td className="text-center"></td>
                                            <td className="text-center">{this.state.is_vat ? toFixed((Number(this.state.total_price) - Number(this.state.discount)) * 0.07).replaceAll(",", "") : "0.00"}</td>
                                        </tr>
                                    )}
                                    <tr className="border-bottom">
                                        <td className="text-center">
                                            ราคาชำระรวม
                                        </td>
                                        <td className="text-center"></td>
                                        <td className="text-center"><h3><b>{toFixed(this.state.total_price - Number(this.state.discount) + (this.state.is_vat ? Number(toFixed((Number(this.state.total_price) - Number(this.state.discount)) * 0.07).replaceAll(",", "")) : 0))}</b></h3></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="w-100 d-flex">
                            <div className="w-50 pe-1">
                                <button className="btn btn-outline-orange w-100" onClick={() => { this.setState({ modal_sub_pay: false }) }}>
                                    ยกเลิก
                                </button>
                            </div>
                            <div className="w-50 ps-1">
                                <button className="btn btn-orange w-100"
                                    onClick={() => {
                                        this.setState({
                                            modal_sub_pay: false,
                                            transfer_date: format_date(new Date(), "yyyy-mm-dd"),
                                            transfer_time: format_date(new Date(), "hh:mm"),
                                        })
                                        if (!this.state.is_payment) {
                                            if (this.state.payment_id) {
                                                this.UpdatePayment();
                                            } else {
                                                this.Payment();
                                            }
                                        } else {
                                            this.setState({ modal_payment: true })
                                        }
                                    }}>
                                    {!this.state.is_payment ? "บันทึกข้อมูล" : "ถัดไป"}
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
                {/* payment */}
                <Modal show={this.state.modal_payment}
                    onHide={() => { this.setState({ modal_payment: false }) }}>
                    <Modal.Header><Modal.Title><b>รับชำระ</b></Modal.Title></Modal.Header>
                    <Modal.Body>
                        <div className="row mx-0">
                            <div className="col-4 px-0">
                                <div className={"pointer w-100 p-3 border-3 border-top text-center text-primary" + (this.state.tab === 1 ? " border-primary bg-light" : " border-white bg-white")}
                                    onClick={() => {
                                        this.setState({
                                            tab: 1,
                                            transfer_date: format_date(new Date(), "yyyy-mm-dd"),
                                            transfer_time: format_date(new Date(), "hh:mm"),
                                            total_pay: 0,
                                            bank_name: "",
                                            picture: "",
                                            pay_remark: "",
                                        })
                                    }}>
                                    เงินสด
                                </div>
                            </div>
                            <div className="col-4 px-0">
                                <div className={"pointer w-100 p-3 border-3 border-top text-center text-primary" + (this.state.tab === 2 ? " border-primary bg-light" : " border-white bg-white")}
                                    onClick={() => {
                                        this.setState({
                                            tab: 2,
                                            transfer_date: format_date(new Date(), "yyyy-mm-dd"),
                                            transfer_time: format_date(new Date(), "hh:mm"),
                                            total_pay: (this.state.total_price + (this.state.is_vat ? Number(toFixed((Number(this.state.total_price) - Number(this.state.discount)) * 0.07).replaceAll(",", "")) : 0)),
                                            bank_name: "",
                                            picture: "",
                                            pay_remark: "",
                                        })
                                    }}>
                                    เงินโอน
                                </div>
                            </div>
                            <div className="col-4 px-0">
                                <div className={"pointer w-100 p-3 border-3 border-top text-center text-primary" + (this.state.tab === 3 ? " border-primary bg-light" : " border-white bg-white")}
                                    onClick={() => {
                                        this.setState({
                                            tab: 3,
                                            transfer_date: format_date(new Date(), "yyyy-mm-dd"),
                                            transfer_time: format_date(new Date(), "hh:mm"),
                                            total_pay: (this.state.total_price + (this.state.is_vat ? Number(toFixed((Number(this.state.total_price) - Number(this.state.discount)) * 0.07).replaceAll(",", "")) : 0)),
                                            bank_name: "",
                                            picture: "",
                                            pay_remark: "",
                                        })
                                    }}>
                                    บัตรเครดิต
                                </div>
                            </div>
                        </div>
                        <hr className="mt-0" />
                        {this.state.tab === 1 && (
                            <div>
                                <label className="mb-2">รับเงิน :</label>
                                <input
                                    className="form-control mb-2"
                                    type="text"
                                    placeholder=""
                                    onChange={(e) => {
                                        if (!float(e.target.value)) {
                                            return
                                        }
                                        this.setState({ total_pay: e.target.value })
                                    }}
                                    value={this.state.total_pay}
                                />
                            </div>
                        )}
                        {this.state.tab === 2 && (
                            <div>
                                <label className="mb-2">ธนาคาร :</label>
                                <Select
                                    className="form-control select-search"
                                    styles={select_style}
                                    components={{ Option: IconOption }}
                                    getOptionLabel={(e) => (
                                        <div style={{ display: "flex", alignItems: "center" }} >
                                            <img src={e.icon} style={{ width: 24, marginRight: 16 }} alt={e.label} />
                                            <span style={{ marginLeft: 5 }}>{e.label}</span>
                                        </div>
                                    )}
                                    options={bank}
                                    onChange={(e) => {
                                        this.setState({ bank_name: e });
                                    }}
                                    value={this.statebank_name}
                                    isClearable
                                ></Select>

                                <div className="row">
                                    <div className="col-6">
                                        <label className="mb-2">วันที่ลงข้อมูล :</label>
                                        <DatePicker
                                            className="form-control"
                                            placeholder="พิมพ์คำค้นหา..."
                                            onChange={(e) => {
                                                this.setState({ transfer_date: e });
                                            }}
                                            value={this.state.transfer_date}
                                        />
                                    </div>
                                    <div className="col-6">
                                        <label className="mb-2">เวลาที่โอน :</label>
                                        <input
                                            className="form-control mb-2"
                                            type="time"
                                            placeholder=""
                                            onChange={(e) => {
                                                this.setState({ transfer_time: e.target.value })
                                            }}
                                            value={this.state.transfer_time}
                                        />
                                    </div>
                                </div>
                                <div className="w-100 mb-2">
                                    {this.state.picture === "" ? (
                                        <div
                                            className="w-100 pointer card d-flex align-items-center justify-content-center px-3 py-5 bg-light rounded hpx-40"
                                            onClick={() => { document.getElementById("file").click() }}
                                        >
                                            <label className="text-secondary pointer"><label className="icon text-secondary pointer me-2">{"\uf0ee"}</label>อัปโหลดรูปภาพ</label>
                                        </div>
                                    ) : (
                                        <div className="w-100 card border-2 border-orange d-flex align-items-center justify-content-center p-2  mb-2">
                                            <div className="position-relative w-100">
                                                <img alt="รูปสาขา" src={this.state.picture.includes("https://") ? this.state.picture : "data:image/png;base64," + this.state.picture} className="w-100 rounded overflow-hidden"></img>
                                                <div className="icon pointer bg-danger text-white position-absolute wpx-30 hpx-30 d-flex justify-content-center align-items-center rounded-circle" style={{ top: -8, right: -8 }} onClick={() => { this.setState({ picture: "" }) }}>
                                                    {"\uf00d"}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    <input className="d-none" type="file" id="file" accept="image/*" onChange={(e) => { this.import_file(e, "main") }} />
                                </div>
                                <label className="mb-2">หมายเหตุ :</label>
                                <input
                                    className="form-control mb-2"
                                    type="text"
                                    placeholder=""
                                    onChange={(e) => { this.setState({ pay_remark: e.target.value }) }}
                                    value={this.state.pay_remark}
                                />
                            </div>
                        )}
                        {this.state.tab === 3 && (
                            <div>
                                <label className="mb-2">ประเภทบัตร :</label>
                                <Select
                                    className="form-control select-search"
                                    styles={select_style}
                                    components={{ Option: IconOption }}
                                    getOptionLabel={(e) => (
                                        <div style={{ display: "flex", alignItems: "center" }} >
                                            <img src={e.icon} style={{ width: 24, marginRight: 16 }} alt={e.label} />
                                            <span style={{ marginLeft: 5 }}>{e.label}</span>
                                        </div>
                                    )}
                                    options={credit}
                                    onChange={(e) => {
                                        this.setState({ credit_card: e });
                                    }}
                                    value={this.state.credit_card}
                                    isClearable
                                ></Select>
                                <label className="mb-2">รหัสบัตร 4 ตัวท้าย :</label>
                                <input
                                    className="form-control mb-2"
                                    type="text"
                                    placeholder=""
                                    onChange={(e) => { this.setState({ pin_card: e.target.value }) }}
                                    value={this.state.pin_card}
                                />
                                <label className="mb-2">หมายเหตุ :</label>
                                <input
                                    className="form-control mb-2"
                                    type="text"
                                    placeholder=""
                                    onChange={(e) => { this.setState({ pay_remark: e.target.value }) }}
                                    value={this.state.pay_remark}
                                />
                            </div>
                        )}
                        <div className="card p-3 bg-primary">

                            {this.state.tab === 1 && (
                                <div className="w-100 d-flex justify-content-between align-items-center">
                                    <label className="text-white">เงินทอน</label>
                                    <h4 className="text-white"><b>{toFixed(Number(this.state.total_pay) - (this.state.total_price + (this.state.is_vat ? Number(toFixed((Number(this.state.total_price) - Number(this.state.discount)) * 0.07).replaceAll(",", "")) : 0)) > 0 ? Number(this.state.total_pay) - (this.state.total_price + (this.state.is_vat ? Number(toFixed((Number(this.state.total_price) - Number(this.state.discount)) * 0.07).replaceAll(",", "")) : 0)) : 0)}</b></h4>
                                </div>
                            )}
                            <div className="w-100 d-flex justify-content-between align-items-center">
                                <label className="text-white">ยอดรวมที่ชำระ</label>
                                <h3 className="text-white"><b>{toFixed((this.state.total_price + (this.state.is_vat ? Number(toFixed((Number(this.state.total_price) - Number(this.state.discount)) * 0.07).replaceAll(",", "")) : 0)))}</b></h3>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="w-100 d-flex">
                            <div className="w-50 pe-1">
                                <button className="btn btn-outline-orange w-100" onClick={() => {
                                    this.setState({ modal_payment: false })
                                }}>
                                    ยกเลิก
                                </button>
                            </div>
                            <div className="w-50 ps-1">
                                <button className="btn btn-orange w-100"
                                    onClick={() => {
                                        if (this.state.payment_id) {
                                            this.UpdatePayment();
                                        } else {
                                            this.Payment();
                                        }
                                    }}>
                                    ตกลง
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div >
        )
    }
}
